var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.469,
    d: "M6 3h8a2 2 0 012 2v14h0H4V5a2 2 0 012-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 11,
    r: 1,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.469,
    d: "M1.958 19.044h16.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 12h12v12H12z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 0.625
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.455,
    d: "M7 3L3 7M3 3l4 4"
  })))));
}
export default SvgRoomSize;